// An https page can't load an http stream, so those fallbacks would only spend an attempt failing.
export default function streamUrls(nowPlaying, pageProtocol = window.location.protocol) {
  let fallbacks = (nowPlaying?.streamFallbackUrls ?? []).filter(
    (url) => pageProtocol !== 'https:' || url?.startsWith('https:')
  );

  return [...new Set([nowPlaying?.streamUrl, ...fallbacks].filter(Boolean))];
}
